<template>
  <div class="page-view">
    <div class="header-row">
      <div>
        <h2>关联分管</h2>
        <p>按管理员配置关联关系。每个管理员都可以勾选多个其他管理员，保存后关系自动按双向生效。</p>
      </div>
    </div>

    <div class="brand-card filter-card">
      <div class="toolbar-row">
        <el-input v-model="filters.keyword" placeholder="管理员姓名" clearable />
        <el-button type="primary" plain @click="loadItems">查询</el-button>
      </div>
    </div>

    <div class="brand-card table-card">
      <el-table :data="items" stripe>
        <el-table-column prop="admin_name" label="管理员" min-width="160" />
        <el-table-column label="可关联管理员" min-width="520">
          <template slot-scope="{ row }">
            <el-checkbox-group v-model="row.related_admin_ids">
              <el-checkbox v-for="item in row.available_admins" :key="item.id" :label="item.id">
                {{ item.name }}
              </el-checkbox>
            </el-checkbox-group>
          </template>
        </el-table-column>
        <el-table-column label="已选数量" width="120">
          <template slot-scope="{ row }">{{ row.related_admin_ids.length }}</template>
        </el-table-column>
        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="{ row }">
            <el-button size="mini" type="primary" @click="saveRow(row)">保存</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { fetchAdminRelations, updateAdminRelations } from "../api/orders";

export default {
  data() {
    return {
      filters: { keyword: "" },
      items: [],
    };
  },
  mounted() {
    this.loadItems();
  },
  methods: {
    async loadItems() {
      const { data } = await fetchAdminRelations({
        keyword: this.filters.keyword || undefined,
      });
      this.items = (data.items || []).map((item) => ({
        ...item,
        related_admin_ids: [...(item.related_admin_ids || [])],
      }));
    },
    async saveRow(row) {
      await updateAdminRelations(row.admin_id, {
        admin_id: row.admin_id,
        related_admin_ids: row.related_admin_ids,
      });
      this.$message.success(`已保存 ${row.admin_name} 的关联配置`);
      this.loadItems();
    },
  },
};
</script>

<style scoped>

:deep(.el-checkbox-group) {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 18px;
}

:deep(.el-checkbox) {
  margin-right: 0;
}
</style>
